module.exports = __webpack_public_path__ + "img/cross.80d14efc.svg";